<div class="container">

  <mat-horizontal-stepper class="mat-elevation-z8" labelPosition="bottom" #loanProductStepper>

    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="loanProductDetailsForm">

      <ng-template matStepLabel>DETAILS</ng-template>

      <mifosx-loan-product-details-step [loanProductsTemplate]="loanProductsTemplate"></mifosx-loan-product-details-step>

    </mat-step>

    <mat-step [stepControl]="loanProductCurrencyForm">

      <ng-template matStepLabel>CURRENCY</ng-template>

      <mifosx-loan-product-currency-step [loanProductsTemplate]="loanProductsTemplate"></mifosx-loan-product-currency-step>

    </mat-step>

    <mat-step [stepControl]="loanProductTermsForm">

      <ng-template matStepLabel>TERMS</ng-template>

      <mifosx-loan-product-terms-step [loanProductsTemplate]="loanProductsTemplate"></mifosx-loan-product-terms-step>

    </mat-step>

    <mat-step [stepControl]="loanProductSettingsForm">

      <ng-template matStepLabel>SETTINGS</ng-template>

      <mifosx-loan-product-settings-step
        [loanProductsTemplate]="loanProductsTemplate"
        [isLinkedToFloatingInterestRates]="loanProductTermsForm.get('isLinkedToFloatingInterestRates')"
      >
      </mifosx-loan-product-settings-step>

    </mat-step>

    <mat-step>

      <ng-template matStepLabel>CHARGES</ng-template>

      <mifosx-loan-product-charges-step
        [loanProductsTemplate]="loanProductsTemplate"
        [currencyCode]="loanProductCurrencyForm.get('currencyCode')"
        [multiDisburseLoan]="loanProductSettingsForm.get('multiDisburseLoan')"
      >
      </mifosx-loan-product-charges-step>

    </mat-step>

    <mat-step [stepControl]="loanProductAccountingForm">

      <ng-template matStepLabel>ACCOUNTING</ng-template>

      <mifosx-loan-product-accounting-step
        [loanProductsTemplate]="loanProductsTemplate"
        [accountingRuleData]="accountingRuleData"
        [loanProductFormValid]="loanProductFormValid"
      >
      </mifosx-loan-product-accounting-step>

    </mat-step>

    <mat-step state="preview" *ngIf="loanProductFormValid" completed>

      <ng-template matStepLabel>PREVIEW</ng-template>

      <mifosx-loan-product-preview-step
        [loanProductsTemplate]="loanProductsTemplate"
        [accountingRuleData]="accountingRuleData"
        [loanProduct]="loanProduct"
        (submit)="submit()"
      >
      </mifosx-loan-product-preview-step>

    </mat-step>

  </mat-horizontal-stepper>

</div>
